import { TYPES } from "@/view/ProseMirrorNode/ProseMirrorNode.constants";

export const getParagraphIsAllSpecialCharacters = (node) => {
  const isParagraph = node?.type === TYPES.paragraph;
  const paragraphText = isParagraph && node?.content?.[0]?.text;

  if (!paragraphText) return;

  const regexForSpecialCharacters = /^[^a-zA-Z0-9]+$/;
  const paragraphIsAllSpecialCharacters =
    regexForSpecialCharacters.test(paragraphText);

  return paragraphIsAllSpecialCharacters;
};

export default getParagraphIsAllSpecialCharacters;
